define('GameDayCore/GDUtil/window/WindowBridge',['require','exports','module','./Logg'],function(require,exports,module) {
    var logg = require("./Logg"),
        origination = "http://" + document.location.host,
        eventHash = {};

    exports.dispatchMessage = function(msg) {
        try {
            parent.window.postMessage(msg, origination);
        } catch (err) {
            logg.log("parent.window.postMessage has failed.");
        }
    };

    exports.addListener = function(listener, callback) {
        eventHash[listener] = callback;

    };

    exports.removeListener = function(listener) {
        eventHash[listener] = undefined;
        delete eventHash[listener];
    };
    
    function addWindowListener() {
        if(window === parent) {
            //console.log('Window Listener not added, window already equals parent, you jabroni!');
            return;
        }
        if (!!parent.window.addEventListener) {
            parent.window.addEventListener("message", handleWindowMessage, true);
        } else if (!!parent.window.attachEvent) {
            parent.window.attachEvent("message", handleWindowMessage);
        } else {
            logg.log("Unable to attach listener to parent.window");
        };

    }
    
    function handleWindowMessage(message) {
        var msg = message.data.split("~");
        var evt = msg.shift();
        logg.log("attempting to call function for event: " + evt);
        if (!!eventHash[evt]) {
            if (msg.length > 0) { eventHash[evt](msg); }
            else { eventHash[evt](); }
        };
    }

    exports.init = function() {
        addWindowListener();
    }
});
